module.exports = __webpack_public_path__ + "img/68.6937848b.png";